export const resourceLinkData = [
    {
        id: 1,
        resourceTitle: "Year 13 chemistry health check",
        imageLink: "/images/resources/health-check.png",
        altText: "graphic illustration of heart pulse rate",
        hyperLink: "year-13-chemistry-health-check",
        hyperLinkExternal: 'false',
        resourceDescription: "A health check for students going into year 13 to eliminate misconceptions about the year 12 content.",
        lastUpdated: "21-9-23"
    },
    {
        id: 2,
        resourceTitle: "Reactions of complex ions",
        imageLink: "/images/resources/colourful-solutions.jpg",
        altText: "brightly coloured solutions in conical flasks",
        hyperLink: "https://nowchemistry.com/transition-metals/introduction/",
        hyperLinkExternal: 'true',
        resourceDescription: "A simulation of the reactions of complex ions produced by transition metals such as copper, cobalt and iron.",
        lastUpdated: "21-9-23"
    }
]

